export default [
	{
		path: '/information/detail/:id/:type?',
		name: 'InformationDetail',
		component: () => import('@/views/information/detail.vue')
	},
	{
		path: '/information/kagfu/:id',
		name: 'kangfuDetail',
		component: () => import('@/views/information/kangfu-detail.vue'),
		meta: { title: '动作详情' }
	}
]
